import { useContext, createContext } from "react";
import { Button, Card, Space, Typography } from "antd";
import { useNavigate } from "react-router-dom";

import { masterPageStore as MasterPageStore } from "../store/MasterPageStore";
import IMG1 from "../img/baba1.jpg"
import IMG2 from "../img/baba7.png"
import IMG3 from "../img/baba3.jpg"
import IMG4 from "../img/baba4.jpg"
import IMG5 from "../img/baba5.jpg"
import IMG6 from "../img/baba6.png"
import IMG8 from "../img/baba8.jpeg"
import logo from "../../Home/img/logo.gif"
import HERO_BG from "../img/hero_bg.png"
import { getCurrentUser } from "../../../Utility/helper";
import { permissionStore } from "../store/PermissionStore";
import "../styles/landingMainPageStyle.css"
import { homeStore } from "../../Home/store/HomeStore";
import { signUpView } from "../../Home/types/interfaces";
// const { useDevice } = require("react-use-device");
type Props = {};
const greet = require("greet-by-time");
const masterPageStoreCtx = createContext(MasterPageStore);
const permissionStoreCtx = createContext(permissionStore);
const { Meta } = Card;
const LandingMainPage = (props: Props) => {
  // let { reqId } = useParams();
  const hour = new Date().getHours();
  greet.morningGreetings = ["Good Morning", "Awesome Morning", "Welcome Back"];
  greet.dayGreetings = ["Good Afternoon", "Awesome Afternoon", "Welcome Back"];
  greet.eveningGreetings = ["Good Evening", "Awesome Evening", "Welcome Back"];
  const masterPageStore = useContext(masterPageStoreCtx);
  // const ManageFacilityStore = useContext(manageFacilityStoreCtx);
  const PermissionStore = useContext(permissionStoreCtx);
  let navigate = useNavigate();
  const user = getCurrentUser()?.fullName;
  // const { isMOBILE, isDESKTOP,isTABLET } = useDevice();
  const year = (new Date()).getFullYear();

  return (
    <main className="landing-wrapper">
      <nav className="navbar glass">
        <div className="logo">
          <img src={logo} alt="Logo" />
          <p>ESOCS DATA BANK</p>
        </div>
        <div className="nav-links">
          <Space align="end">
            <Button
              type="link"
              onClick={() => {
                homeStore.signUpView = signUpView.Login;
                navigate("/login");
              }}
              className="nav-btn-link"
            >
              Login
            </Button>
            <Button
              type="primary"
              onClick={() => {
                homeStore.signUpView = signUpView.Register;
                navigate("/login");
              }}
              className="signup-btn-premium"
            >
              Sign Up Now
            </Button>
          </Space>
        </div>
      </nav>

      <section className="hero-section fade-up">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-text-area">
            <h1 className="hero-title">
              Empowering the <span className="highlight">Church</span> Through Data
            </h1>
            <p className="hero-description">
              The ESOCS Data Bank is a state-of-the-art digital infrastructure designed to preserve our heritage,
              streamline administrative excellence, and provide real-time insights for the growth of our Church.
            </p>
            <div className="hero-cta">
              <Button
                type="primary"
                size="large"
                className="cta-primary"
                onClick={() => navigate("/login")}
              >
                Get Started
              </Button>
              <Button
                type="default"
                size="large"
                className="cta-secondary"
                onClick={() => {
                  const el = document.getElementById('leaders');
                  el?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Meet Our Leaders
              </Button>
            </div>
          </div>
          <div className="hero-visual-area">
            <div className="hero-glass-card">
              <div className="stat-item">
                <span className="stat-value">100%</span>
                <span className="stat-label">Secure Access</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">Real-time</span>
                <span className="stat-label">Church Analytics</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="leaders" className="leaders-container">
        <h2 className="section-title fade-up delay-1">Our Church Leaders</h2>

        {/* Featured Leader */}
        <div className="featured-leader fade-up delay-2">
          <div className="leader-card">
            <div className="leader-image-container">
              <img src={IMG5} alt="His Most Eminence, Baba Aladura" />
            </div>
            <div className="leader-info">
              <p className="leader-title">HIS MOST EMINENCE, BABA ALADURA</p>
              <h2 className="leader-name">(DR) DAVID D.L BOBMANUEL</h2>
            </div>
          </div>
        </div>

        {/* Deputy Leaders Grid */}
        <div className="leaders-grid">
          <div className="leader-card fade-up delay-3">
            <div className="leader-image-container">
              <img src={IMG4} alt="His Eminence, Deputy Baba Aladura" />
            </div>
            <div className="leader-info">
              <p className="leader-title">HIS EMINENCE, DEPUTY BABA ALADURA</p>
              <h2 className="leader-name">NATHAN OJIAKOR</h2>
            </div>
          </div>

          <div className="leader-card fade-up delay-4">
            <div className="leader-image-container">
              <img src={IMG3} alt="His Eminence, Deputy Baba Aladura" />
            </div>
            <div className="leader-info">
              <p className="leader-title">HIS EMINENCE, DEPUTY BABA ALADURA</p>
              <h2 className="leader-name">J. F. FARINLOYE</h2>
            </div>
          </div>

          <div className="leader-card fade-up delay-5">
            <div className="leader-image-container">
              <img src={IMG1} alt="His Eminence, Deputy Baba Aladura" />
            </div>
            <div className="leader-info">
              <p className="leader-title">HIS EMINENCE, DEPUTY BABA ALADURA</p>
              <h2 className="leader-name">(DR) HAROLD DUMUREN</h2>
            </div>
          </div>
        </div>

        {/* Secondary Leaders Grid (New Row) */}
        <div className="secondary-leaders-grid">
          <div className="leader-card fade-up delay-6">
            <div className="leader-image-container">
              <img src={IMG6} alt="Leader" />
            </div>
            <div className="leader-info">
              <p className="leader-title">HIS EMINENCE DEPUTY BABA ALADURA</p>
              <h2 className="leader-name">JIMMY NKPOIDET</h2>
            </div>
          </div>

          <div className="leader-card fade-up delay-7">
            <div className="leader-image-container">
              <img src={IMG8} alt="Leader" />
            </div>
            <div className="leader-info">
              <p className="leader-title">HIS EMINENCE DEPUTY BABA ALADURA</p>
              <h2 className="leader-name">DR. ISAAC BELLO</h2>
            </div>
          </div>
        </div>

        {/* Single Leader */}
        <div className="single-leader fade-up delay-7">
          <div className="leader-card">
            <div className="leader-image-container">
              <img src={IMG2} alt="Deputy Baba Aladura" />
            </div>
            <div className="leader-info">
              <p className="leader-title">HIS EMINENCE </p>
              <h2 className="leader-name">ELDER DR. I. U. OMOIKE </h2>
              <p className="leader-title">SECRETARY TO THE ORDER</p> 
            </div>
          </div>
        </div>
      </section>

      <footer>
        <p>&copy; {year} ESOCS DATA BANK | ALL RIGHTS RESERVED</p>
      </footer>
    </main>
  );
};


export default LandingMainPage;
